<template>
    <div class="body-container">
         <div class='b-body'>
            <div class='b-header'>
                <div class="header-menu">
                   <div v-if="$isShowLogo" class="menu-item header-logo"></div>
                    <div class="menu-item"></div>
                    <div :class='{ active:index===number}' v-for="(item,index) in tabs" :key=item.id @click="handleClickTab(item,index)" class="menu-item">{{item.name}}</div>
                </div>
                <div class="header-title">
                    电力设备状态智能监测系统
                </div>
                <div class="header-right">
                    <!-- <el-select v-model="language" size="mini" placeholder="请选择" popper-class="dark-style">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select> -->
                    <span class="time">{{currentTime}}</span>
                    <!-- <button @click="users"><i class="el-icon-user"></i></button>    -->
                    <i class="el-icon-user" style="font-size: 26px;"></i>
                    <el-dropdown  trigger="click" @command="handleCommand">
                        <button @click="users"><span style="font-size: 20px; color: #fff;margin-right: 8px;">{{'hi，' + userInfo.username}}</span></button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>修改信息</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <button @click="trun()"><i class="el-icon-coin" style="font-size: 26px;"></i></button>
                    <button @click="logOut()"><i class="el-icon-switch-button" style="font-size: 26px;"></i></button>
                </div>
                <div style="clear:both;"></div>
            </div>
            <div class='b-main'>
                <router-view></router-view>
            </div>
        </div>
        <div v-if="editUserDialog" class="edit-user">
            <el-dialog title="修改信息" :visible.sync="editUserDialog"  width="500px">
                <el-form :model="form">
                    <el-form-item label="密码:" :label-width="formLabelWidth">
                        <el-input v-model="form.password" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱:" :label-width="formLabelWidth">
                        <el-input v-model="form.email" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电话:" :label-width="formLabelWidth">
                        <el-input v-model="form.phone" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="editUserDialog = false">取 消</el-button>
                    <el-button type="primary" @click="editUserInfo">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import * as account from '@/data/api.js'
    import Bus from "@/util/Bus.js";
    export default {
        data(){
            return {
                userInfo:JSON.parse(localStorage.getItem('userInfo')),
                activeTab:'sum',
                showChart:false,
                currentView:'file',
                number:1,
                tabs:[
                    {name:'综合统计',id:'sum'},
                    {name:'站点详情',id:'site'},
                    {name:'告警管理',id:'warning'},
                    {name:'报告管理',id:'report'},
                ],
                language:1,
                options:[
                    {value:1,label:'简体中文'}
                ],
                currentTime: '',
                editUserDialog: false,
                form:{
                    password:'',
                    email:'',
                    phone:'',
               },
                formLabelWidth: "80px",
            }
    },
    watch: {
        $route: {
            handler: function (val) {
                if (val.name == 'site') {
                    this.activeTab = val.name;
                    this.number = 1;
                }else if (val.name == 'warning') {
                    this.activeTab = val.name;
                    this.number = 2;
                }else if (val.name == 'sum') {
                    this.activeTab = val.name;
                    this.number = 0;
                }else if (val.name == 'report') {
                    this.activeTab = val.name;
                    this.number = 3;
                }
            },
             immediate:true
        },
    },
        mounted(){
            setInterval(this.timeFormat, 1000);
        },
        methods:{
            timeFormat(){
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                if(month < 10){
                  month = '0' + month
                }
                let day = date.getDate()
                if(day < 10){
                  day = '0' + day
                }
                let hours = date.getHours()
                if(hours < 10){
                  hours = '0' + hours
                }
                let min = date.getMinutes()
                if(min < 10){
                  min = '0' + min
                }
                let second = date.getSeconds()
                if(second < 10){
                  second = '0' + second
                }
                this.currentTime = year + '-' + month + '-' + day + " " + hours + ':' + min + ":" + second
            },
            trun(){
                let level = this.userInfo.role_level
                if(level==30){
                    this.$message({
                        message: '普通用户无权限',
                        type: 'warning'
                    });
                } else {
                    this.$router.push('file')
                }
            },
            logOut(){
                let This = this;
                this.$confirm('是否退出系统?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    account.logout().then(res=>{
                        if(res.code==0){
                            localStorage.removeItem('userInfo')
                            localStorage.removeItem('activeTab')
                            Bus.$emit('logout')
                            This.$router.push('login')
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消退出'
                    });
                });
            },
            users(){},
            // 切换tabs
            handleClickTab(tab,idx){
                // this.activeTab = tab.id;
                this.number = idx;
                this.$router.push(tab.id)
            },
            handleCommand(){
                this.editUserDialog = true;
            },
            editUserInfo(){
                account.editUserInfo({data:this.form,userId:this.userInfo.id}).then(res=>{
                    this.editUserDialog = false;
                })
            },

            test() {
                // 给服务器发送一个字符串:
                // ws.send("Hello!");
                this.socket.send(JSON.stringify({data:"Hello!"}));
            }
        }
    }
</script>
<style  lang='less' scoped>
.body-container{
    width:100%;height:100%;overflow: hidden;
    /deep/.el-input__inner{height:28px;line-height: 28px;}
}
.b-body{
    width:100%;height:100%;
}
.b-header{
    width:100%;height:54px;
    position: relative;
    background:rgb(61,63,68);
    color:#fff;
    /* background:#091335; */
}
.b-main{
    width:100%;
    height:calc(100% - 54px);
    background: rgb(33,35,37);
    /* padding:40px 50px 10px 10px; */
    padding:20px;
}
.el-button--primary{
    margin-top: 15px;
}
.el-form-item{
    margin-bottom: 0px;
}
.el-button+.el-button{margin-left: 0;}
.b-header .el-tabs{
    width: 152px;
    height: 50px;
}

.el-input__inner{
    height: 32px;
    line-height: 32px
}
.header-menu{
   height:100%;
   line-height: 54px;
   text-align: center;
   float: left;
   position:absolute;
   font-size:20px;
   z-index: 999;
   left:0px;
   top:0;
}
.menu-item{
    float:left;
    padding:0 10px;height:54px;line-height: 54px;
    border-right:solid 1px #fff;cursor: pointer;
}
.menu-item:hover{
    cursor: pointer;
}
.menu-item.active{
    color:#409EFF;
}
.menu-item:first-child{
    border-right:0;
}
.header-logo{
    width:170px;
    background: url("~@/assets/logo/logo.png") no-repeat center;
    background-size: 94% 94%;
    background-position: 10px 0;
}
.header-title{
    text-align: center;height:54px;line-height: 54px;font-size: 34px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}
.header-right{
    position: absolute;right:10px;top:0;z-index: 1;
    float:right;height:54px;line-height: 54px;
    i{
        font-size: 18px;
        color:#fff;
    }
    button{
        border:0;background:#3D3F44;cursor: pointer;padding-right:5px;
    }
    /deep/.el-select{width:120px;padding-right:10px;}
    /deep/.el-input__inner{
        background:#212325;color:#fff;
    }
    .time{
        padding-right:10px;font-size: 14px;;
    }
    /deep/.el-dropdown-menu{
        padding:0;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/layout/home.vue